
// Define project types
export const PROJECT_TYPE = {
  ZIMMERMAN: "Zimmerman",
  NEXTTRACKER: "Nexttracker"
};

// Helper to set project type in localStorage
export const setProjectTypeInStorage = (projectData) => {
  if (!projectData) return;
  const type = projectData.type === 1 ? PROJECT_TYPE.ZIMMERMAN : PROJECT_TYPE.NEXTTRACKER;
  localStorage.setItem('project_type', type);
};

// Helper to get project type from localStorage
export const getProjectTypeFromStorage = () => {
  return localStorage.getItem('project_type') || PROJECT_TYPE.NEXTTRACKER;
};

// Define all terminology constants
export const PROJECT_TERMS = {
  // Zimmerman terms
  [PROJECT_TYPE.ZIMMERMAN]: {
    TRACKER_LABEL: "Table",
    TRACKERS_LABEL: "Tables",
    BAY_LABEL: "Bay",
    VIEW_SELECTED: "View Selected Tables",
    BOM_FOR_SELECTED: "BOM Status for Selected Tables",
    // Column headers
    SECTION_HEADER: "Row",
    ROW_HEADER: "Table",
  },

  // Nexttracker terms
  [PROJECT_TYPE.NEXTTRACKER]: {
    TRACKER_LABEL: "Tracker",
    TRACKERS_LABEL: "Trackers",
    BAY_LABEL: "Tracker",
    VIEW_SELECTED: "View Selected Trackers",
    BOM_FOR_SELECTED: "BOM Status for Selected Trackers",
    // Column headers
    SECTION_HEADER: "Section",
    ROW_HEADER: "Row",
  }
};

// Shorthand helper to get current terms
export const getCurrentTerms = () => {
  const type = getProjectTypeFromStorage();
  return PROJECT_TERMS[type];
};